import { useLocation } from "react-router";
import AccidentUnitInfo from "../AccidentUnit/AccidentUnitInfo";
import styles from "./Unit.module.css";
import CheckUnitInfo from "../CheckUnit.jsx/CheckUnitInfo";

const UnitListItem = ({ item, index, onClick, currentUnit,  added, unitList, closeModal, setAdded }) => {
  const {pathname} = useLocation()

  
  return (
    <div
      className={currentUnit ? "border-b border-b-gray-500 p-[10px]" : styles["editing-items"]}
      onClick={onClick}
    >
      <p className="cursor-pointer">{index + 1}. {item.unit_number} {item.unit_name} ({item.unit_close_number} զ/մ)</p>
      {pathname.includes("accident-unit") && currentUnit && currentUnit._id === item._id && (
        <div>
          <AccidentUnitInfo unit={currentUnit} added={added} unitList={unitList} closeModal={closeModal} setAdded={setAdded} />
        </div>
      )}
      {pathname.includes("check-unit") && currentUnit && currentUnit._id === item._id && (
        <div>
          <CheckUnitInfo unit={currentUnit} added={added} unitList={unitList} closeModal={closeModal} setAdded={setAdded} />
        </div>
      )}
    </div>
  );
};

export default UnitListItem;
